import React, { Component } from 'react';
import classNames from 'classnames'
import styles from './index.css';
import PAA from '../../blocks/PhoneAndAddress';
import Title from '../../blocks/Title'
import MyIcons from '../../blocks/MyIcons'
import ArrowScroll from '../../blocks/ArrowScroll'
import {LangChangeEventContext} from '../../contexts/LangContext';

var timeIntervalId, arrImgWr, curItem = 0;

export default class Main extends Component {
  state={
    step1:true,
    step2:false
  }
  componentWillMount(){
   
  }
  componentDidMount(){
    this.galleryStart();    
  }
  componentWillUnmount(){
    clearInterval(timeIntervalId);
  }
  galleryStart = () =>{
    arrImgWr = this.galWrap.childNodes;
    arrImgWr[0].classList.add(styles['is-active'])
    curItem ++;
    timeIntervalId = setInterval(()=>{
      if(arrImgWr[curItem]){
        if(curItem<(arrImgWr.length-1)){
          arrImgWr[curItem].classList.remove(styles['is-active']);
          curItem ++;
          arrImgWr[curItem].classList.add(styles['is-active']);
        }else{
          arrImgWr[curItem].classList.remove(styles['is-active']);
          curItem = 0;
          arrImgWr[curItem].classList.add(styles['is-active']);
        }
      }
    },4000)
  }
  handleScrollDown = () =>{
    this.props.handleScrollDown();
  }
  render() {
    return (
      <LangChangeEventContext.Consumer>
        {({lang}) =>(
            <div className={classNames(styles['aboutBody'], 
              this.props.steps[1] && styles['is-step1'], 
              this.props.steps[2] && styles['is-step2'], 
              this.props.steps[3] && styles['is-step3'], 
              this.props.steps[4] && styles['is-step4'], 
              this.props.steps[5] && styles['is-step5'], 
              this.props.steps[6] && styles['is-step6'], 
              this.props.steps[7] && styles['is-step7'], 
              this.props.steps[8] && styles['is-step8'], 
              this.props.steps[9] && styles['is-step9'], 
              this.props.hideArrow && styles['hide-arrow'])
            } >  
              <div className={classNames(styles['backgroundImgWrapper'])} >  
                <img alt="" src={this.props.ADMIN_URL+this.props.bg} className={styles['backgroundImg']} />       
                <div className={classNames(styles['backgroundGradient'])} > </div>           
                <div className={classNames(styles['backgroundLogoWrapper'])} >  
                  <img alt="" src="/assets/logo.jpg" className={styles['backgroundLogoImg']} />  
                </div>
              </div>

              <div className={classNames(styles['contentWrapper'])}>
                <div className={classNames(styles['header'])}>
                  <PAA 
                      classStyle  = {styles['paaStyle']} 
                      iconPlace   = 'place-dark' 
                      iconPhone   = 'phone-dark' 
                      colorStyle  = "black1"/>
                  <Title 
                      classStyle  = {styles['titleStyle']} 
                      colorStyle  = "black1"  
                      title       = "DANTE KITCHEN + BAR" 
                      text        = {lang.t('aboutSubHeader')}
                      logo        = {true}
                  />
                </div>
                <div className={classNames(styles['content'])}>  
                  <div className={styles['wrapperText']} >  
                    <h3 className={styles['wrapperTextTitle']}>{lang.t('aboutTitle')}</h3>
                    <div className={styles['text']} >
                      {lang.t('aboutText')}
                    </div>
                    <div className={styles['spoon']} >  
                      <MyIcons icon="spoon" width="100px" height="100px"/>     
                    </div>
                  </div>
                    
                  <div className={styles['bottomBackgroungImgWrapper']} >  
                    <img alt="" src="/assets/img/test.jpg" className={styles['bottomBackgroungImg']} />                  
                  </div>  
                  <div className={styles['galleryWrapper']} ref={item => {this.galWrap = item}}>  
                    {JSON.parse(this.props.gallery).map( (img,i) => {
                      return(
                        <div className={styles['galleryImgWrapper']} key={i}>  
                          <img alt="" src={this.props.ADMIN_URL+img.image} className={styles['galleryImg']} />                     
                        </div>  
                      )
                    })}
                  </div>

                  

                </div>
                <div className={styles['arrowWrapper']} onClick={this.handleScrollDown}>
                  <ArrowScroll/>
                </div>
              </div>
            </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/MainAbout/index.js